import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/country/importer/countryImporterActions';

export default importerReducers(actions);
